import Sketch from "./components/Sketch";

function App() {
  return (
    <div className="App">
      <Sketch />
    </div>
  );
}

export default App;
